import { render, staticRenderFns } from "./socialmediaicons.vue?vue&type=template&id=2d44042d&scoped=true"
import script from "./socialmediaicons.vue?vue&type=script&lang=js"
export * from "./socialmediaicons.vue?vue&type=script&lang=js"
import style0 from "./socialmediaicons.vue?vue&type=style&index=0&id=2d44042d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d44042d",
  null
  
)

export default component.exports